export const PHONE: string | undefined = process.env.REACT_APP_TEL;

export const PHONE_POST: string | undefined = process.env.REACT_APP_TEL;

export const DOMAIN = process.env.REACT_APP_DOMAIN_LOCALE;
